import React, { createContext, FC, useContext } from 'react';

export const NodeRunsContext = createContext<Set<number> | undefined>(undefined);

interface NodeRunsContextProviderProps {
    runTimes: Set<number> | undefined;
    children: React.ReactNode;
}

export const NodeRunsContextProvider: FC<NodeRunsContextProviderProps> = props => {
    return <NodeRunsContext.Provider value={props.runTimes}>{props.children}</NodeRunsContext.Provider>;
};

export function useNodeRuns() {
    return useContext(NodeRunsContext);
}
